import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { api, apiError } from "@/lib/apiClient";
import { PRODUCT_CATALOG } from "@/lib/productCatalog";
import { toast } from "sonner";

const STATI = { "": "Tutte", aperta: "Aperte", inviata: "Inviate al cliente", confermata: "Confermate", annullata: "Annullate" };
const BADGE = { aperta: "Aperta", inviata: "Inviata al cliente", confermata: "Confermata", annullata: "Annullata" };
const COLORS = { aperta: "bg-slate-100 text-slate-600", inviata: "bg-amber-100 text-amber-800", confermata: "bg-terracotta/15 text-terracotta-hover", annullata: "bg-red-50 text-red-600" };
const label = (code) => PRODUCT_CATALOG[code]?.label || code;
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "—");

// Trattative di tutti i Partner, vista Agenzia (sola lettura).
export default function TrattativeAdmin() {
  const [stato, setStato] = useState("");
  const [rows, setRows] = useState(null);
  useEffect(() => {
    setRows(null);
    api.get("/admin/trattative", { params: { stato } }).then(({ data }) => setRows(data)).catch((e) => { toast.error(apiError(e)); setRows([]); });
  }, [stato]);
  return (
    <div className="space-y-6" data-testid="admin-trattative-page">
      <div>
        <h1 className="flex items-center gap-2 font-heading text-3xl font-semibold text-forest"><ShoppingBag className="h-7 w-7" />Trattative</h1>
        <p className="mt-1 text-sm text-muted-foreground">Le trattative aperte dai Partner con i loro clienti e l'esito della proposta unica.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {Object.entries(STATI).map(([k, v]) => (
          <button key={k || "all"} onClick={() => setStato(k)} data-testid={`trattative-filter-${k || "all"}`}
            className={`rounded-full border px-4 py-1.5 text-xs font-semibold uppercase tracking-wide transition-colors ${stato === k ? "border-forest bg-forest text-white" : "border-forest/30 text-forest hover:bg-sage"}`}>{v}</button>
        ))}
      </div>
      <div className="overflow-x-auto rounded-2xl border bg-white">
        <table className="w-full text-sm">
          <thead className="bg-sage text-left text-xs uppercase tracking-wide text-muted-foreground">
            <tr><th className="px-4 py-3">Cliente</th><th className="px-4 py-3">Partner</th><th className="px-4 py-3">Prodotti</th><th className="px-4 py-3">Stato</th><th className="px-4 py-3">Aggiornata</th></tr>
          </thead>
          <tbody>
            {rows === null && <tr><td colSpan={5} className="px-4 py-6 text-muted-foreground">Caricamento…</td></tr>}
            {rows?.length === 0 && <tr><td colSpan={5} className="px-4 py-6 text-muted-foreground" data-testid="trattative-empty">Nessuna trattativa.</td></tr>}
            {rows?.map((t) => (
              <tr key={t.id} className="border-t hover:bg-sage/50" data-testid={`trattativa-row-${t.id}`}>
                <td className="px-4 py-3 font-medium text-forest">{t.cliente_nome || "—"}</td>
                <td className="px-4 py-3">{t.partner_nome || "—"}</td>
                <td className="px-4 py-3">{(t.items || []).map(label).join(", ") || "—"}</td>
                <td className="px-4 py-3"><span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${COLORS[t.stato] || ""}`}>{BADGE[t.stato] || t.stato}</span></td>
                <td className="px-4 py-3 text-muted-foreground">{fmt(t.updated_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-muted-foreground">Per le singole pratiche vai a <Link to="/admin/preventivi" className="text-terracotta-hover underline">Preventivi</Link>.</p>
    </div>
  );
}
